import { createBrowserInspector } from '@b2b/common/utils/xstate';
import { LooseAutocomplete } from '@b2b/types/core/utils';
import angular, { IWindowService } from 'angular';

type B2BInspectors = LooseAutocomplete<'ordersDetail'>;

export class XStateInspectorService {
  static $inject = ['$window'];
  private inspectors = new Map<B2BInspectors, ReturnType<typeof createBrowserInspector>>();

  constructor(private $window: IWindowService) {}

  init() {
    if (this.$window.__ACME_B2B__ == null) {
      this.$window.__ACME_B2B__ = {};
    }

    this.$window.__ACME_B2B__.XStateInspectorService = {
      register: (key) => this.register(key),
      get: (key) => this.get(key),
    };
  }

  register(key: B2BInspectors) {
    if (this.inspectors.has(key)) {
      return this.inspectors.get(key);
    }

    const inspector = createBrowserInspector();
    this.inspectors.set(key, inspector);

    return inspector;
  }

  get(key: B2BInspectors) {
    return this.inspectors.get(key);
  }
}

export const XStateInspectorServiceModule = angular
  .module('acme.common.service.xstate.inspector', [])
  .service('XStateInspectorService', XStateInspectorService).name;
